import type { AdminApiOrganization } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

type AdminOrganizationsResponse =
  | AdminApiOrganization[]
  | {
      data?: AdminApiOrganization[];
    };

const normalizeOrganizations = (payload: AdminOrganizationsResponse): AdminApiOrganization[] => {
  if (Array.isArray(payload)) {
    return payload;
  }
  return payload.data ?? [];
};

export default function useFetchAdminOrganizations() {
  return useQuery({
    queryKey: ['admin', 'organizations'],
    queryFn: async () => {
      const response = await fetch('/admin/api/organizations');
      if (!response.ok) {
        throw new Error('組織一覧の取得に失敗しました');
      }
      const data: AdminOrganizationsResponse = await response.json();
      return normalizeOrganizations(data);
    },
  });
}
